import React from "react"
import SidebarNav from "./SidebarNav"
import { ArrowLeftRight } from "lucide-react"
import useSidebar from "../../hooks/useSidebar"
import { SIDEBAR_BEHAVIOR } from "../../constants"

const Sidebar = ({ items }) => {
  const { isOpen, setIsOpen } = useSidebar()

  const onCompact = () => {
    document.body.dataset.sidebarBehavior =
      document.body.dataset.sidebarBehavior === SIDEBAR_BEHAVIOR.COMPACT
        ? SIDEBAR_BEHAVIOR.STICKY
        : SIDEBAR_BEHAVIOR.COMPACT

    setIsOpen(document.body.dataset.sidebarBehavior === SIDEBAR_BEHAVIOR.STICKY)
  }

  return (
    <nav className="sidebar">
      <div className="sidebar-content">
        <div
          className={`tw:mb-6 tw:flex tw:justify-between tw:px-3 tw:py-3 ${isOpen ? "tw:justify-between" : "tw:justify-center"}`}
        >
          <a
            className={`tw:flex tw:items-center tw:gap-2 tw:pl-2 tw:hover:no-underline! ${!isOpen && "tw:hidden"}`}
            href="/"
          >
            <img
              alt="logo"
              className="tw:w-[30px]"
              src="/inspire_logo_white.png"
            />
            <span className="tw:text-2xl tw:text-white!">Inspire</span>
          </a>
          <span
            className="tw:flex tw:items-center tw:justify-center tw:p-2 tw:hover:cursor-pointer!"
            onClick={onCompact}
          >
            <ArrowLeftRight
              color="white"
              size={26}
              strokeWidth={1.5}
              className="tw:self-center"
            />
          </span>
        </div>

        <SidebarNav items={items} />
      </div>
    </nav>
  )
}

export default Sidebar
